// extracted by mini-css-extract-plugin
export default {"report_info":"wongInfo_report_info__bo7Sg"};